import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { FormPageLayout } from '../../common';
import SavedNotification from './SavedNotification';
import NotificationManagementDetails from './NotificationManagementDetails';
import NotificationManagementForm from './NotificationManagementForm';

function NotificationManagement({ notificationTemplates, ...rest }) {
  return (
    <FormPageLayout
      {...rest}
      data={notificationTemplates}
      detailsComponent={NotificationManagementDetails}
      formComponent={NotificationManagementForm}
      hasData={!isEmpty(notificationTemplates)}
      itemComponent={SavedNotification}
      title="Notification Management"
    />
  );
}

NotificationManagement.propTypes = {
  notificationTemplates: PropTypes.array,
};

NotificationManagement.defaultProps = {
  notificationTemplates: [],
};

export default NotificationManagement;



// WEBPACK FOOTER //
// ./src/modules/NotificationManagement/components/NotificationManagementPage.js